/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmMarketplaceInfo } from './EvmMarketplaceInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type SomniaNftItemProfileInfo = {
    TKNSMR: EvmTokenSummaryInfo;
    TKNT: SomniaNftItemProfileInfo.TKNT;
    TKNID: string;
    TKIMG: string;
    OWN: string;
    CRT: string;
    CTRXHA: string;
    OWNCNT: string;
    TSP: string;
    QTY: string;
    LT: string;
    TTKNSMR: EvmTokenSummaryInfo;
    MKPCLIST: Array<EvmMarketplaceInfo>;
};

export namespace SomniaNftItemProfileInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

